import { render, staticRenderFns } from "./CultureHistoryShow.vue?vue&type=template&id=33b7925e&scoped=true&"
import script from "./CultureHistoryShow.vue?vue&type=script&lang=js&"
export * from "./CultureHistoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7925e",
  null
  
)

export default component.exports